package repositories

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.engine.HttpClientEngine
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.request.get
import io.ktor.http.HttpStatusCode
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import practicetest.TopicListResponse
import uk.co.happyukrainians.HttpClientEngineForPlatform

class HttpClientTopicRepository(engine: HttpClientEngine = HttpClientEngineForPlatform()) : TopicRepository {
    private val client: HttpClient = HttpClient(engine) {
        install(ContentNegotiation) {
            json(Json { ignoreUnknownKeys = true })
        }
    }

    override suspend fun fetchTopics(forSubject: String): Result<TopicListResponse> {
        return try {
            val httpResponse = client.get("https://api.happyukrainian.com/subject/$forSubject/topics").call.response
            if (httpResponse.status != HttpStatusCode.OK) {
                Result.failure(TopicRepositoryException(isNetwork = false))
            } else {
                Result.success(httpResponse.body<TopicListResponse>())
            }
        } catch (e: Throwable) {
            Result.failure(TopicRepositoryException(isNetwork = true))
        }
    }
}